export default {
  documentationList: [],
  currentDocumentationPage: {},
  attachments: {},
  loadingDocumentationPage: false,
  loadingDocumentationList: false,
  modalContent: undefined,
  modalShowing: false,
  refreshTree: true,
  refreshDocument: true,
  uploadedDocId: 0,
  showTreePanel: false,
  newNode: null
}
